/* ==========================================================================
   Shop by Categories: encaje del escenario 1920×965, cambio de categoría y
   dots del carrusel. El Figma pinta los dots como imagen; aquí se generan
   según el número de slides visibles.
   ========================================================================== */

(function () {
  'use strict';

  /* Rediseño v2: layout fluido, sin escenario escalado. Solo se limpian los
     inline styles que pudiera haber dejado la versión anterior. */
  function fit() {
    var roots = document.querySelectorAll('[data-cats="root"]');
    for (var i = 0; i < roots.length; i++) {
      roots[i].style.removeProperty('--cats-scale');
      roots[i].style.removeProperty('height');
    }
  }

  function selectTab(root, id) {
    var tabs = root.querySelectorAll('[data-cats-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var active = tabs[i].dataset.catsTab === id;
      tabs[i].classList.toggle('is-active', active);
      tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
    }
    var panels = root.querySelectorAll('[data-cats-panel]');
    var shown = null;
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].dataset.catsPanel !== id;
      if (!panels[j].hidden) shown = panels[j];
    }
    if (shown) {
      /* Stagger de entrada de las cards (re-disparable en cada cambio) */
      shown.classList.remove('is-staggering');
      void shown.offsetWidth;
      shown.classList.add('is-staggering');
      var track = shown.querySelector('[data-cats-track]');
      if (track) track.scrollTo({ left: 0 });
    }
    buildDots(root);
  }

  /** Un dot por "página" del track (tantas slides como quepan a la vez). */
  function buildDots(root) {
    var panels = root.querySelectorAll('[data-cats-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].hidden) continue;
      var track = panels[i].querySelector('[data-cats-track]');
      var dots = panels[i].querySelector('[data-cats-dots]');
      if (!track || !dots) continue;

      /* Con el rediseño el track son .gyaa-cats__page de 100%: contarlas evita
         que el gap entre páginas invente una página fantasma en el ceil. */
      var pageEls = track.querySelectorAll('.gyaa-cats__page');
      var pages = pageEls.length || Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, track.clientWidth)));

      /* Una sola página no se pagina: un punto suelto sugiere que hay más
         contenido del que hay. Con la regla de páginas completas (7-ago) esto
         pasa en cuanto una categoría tiene menos de 9 productos. */
      dots.hidden = pages <= 1;
      if (dots.hidden) {
        dots.textContent = '';
        continue;
      }

      if (dots.childElementCount !== pages) {
        dots.textContent = '';
        for (var p = 0; p < pages; p++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gyaa-cats__dot';
          dot.dataset.page = String(p);
          dots.appendChild(dot);
        }
      }
      syncDots(track, dots);
    }
  }

  /** Paso real entre páginas (ancho + gap); fallback al ancho visible. */
  function pageStep(track) {
    var pageEls = track.querySelectorAll('.gyaa-cats__page');
    if (pageEls.length > 1) return pageEls[1].offsetLeft - pageEls[0].offsetLeft;
    return Math.max(1, track.clientWidth);
  }

  function syncDots(track, dots) {
    var page = Math.round(track.scrollLeft / pageStep(track));
    var children = dots.children;
    for (var i = 0; i < children.length; i++) {
      children[i].classList.toggle('is-active', i === page);
    }
  }

  function bind(root) {
    if (root.dataset.catsBound === 'true') return;
    root.dataset.catsBound = 'true';

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-cats-tab]');
      if (tab) {
        selectTab(root, tab.dataset.catsTab);
        return;
      }
      var dot = event.target.closest('.gyaa-cats__dot');
      if (dot) {
        var track = dot.closest('[data-cats-panel]').querySelector('[data-cats-track]');
        if (track) {
          track.scrollTo({ left: pageStep(track) * Number(dot.dataset.page), behavior: 'smooth' });
        }
      }
    });

    root.addEventListener(
      'scroll',
      function (event) {
        var track = event.target;
        if (!track.matches || !track.matches('[data-cats-track]')) return;
        var dots = track.parentNode.querySelector('[data-cats-dots]');
        if (dots) syncDots(track, dots);
      },
      true
    );
  }

  function init() {
    fit();
    var roots = document.querySelectorAll('[data-cats="root"]');
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
      buildDots(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(init, 120);
  });

  document.addEventListener('shopify:section:load', init);
})();
